module.exports = __webpack_public_path__ + "img/3.2a69eb8a.svg";